import Headroom from "headroom.js";
export function headroom() {
	//header class
	const headerClass = "main-header";
	// select your header or whatever element you wish
	const header = document.querySelector("header:not(:has(.overlay-menu.active))");

	var options = {
		// vertical offset in px before element is first unpinned
		offset: header.offsetTop,

		// scroll tolerance in px before state changes
		tolerance: 20,

		// css classes to apply
		classes: {
			// when element is initialised
			initial: `${headerClass}`,
			// when scrolling up
			pinned: `${headerClass}--pinned`,
			// when scrolling down
			unpinned: `${headerClass}--unpinned`,
			// when above offset
			top: `${headerClass}--top`,
			// when below offset
			notTop: `${headerClass}--not-top`,
			// when at bottom of scroll area
			bottom: `${headerClass}--bottom`,
			// when not at bottom of scroll area
			notBottom: `${headerClass}--not-bottom`,
			// when frozen method has been called
			frozen: `${headerClass}--frozen`,
			// multiple classes are also supported with a space-separated list
			pinned: `${headerClass}--pinned`,
		},
		onUnpin: function () {
			if (header.querySelector(".overlay-menu.active")) {
				header.classList.remove(`${headerClass}--unpinned`);
				header.classList.add(`${headerClass}--pinned`);
			}
		},
	};
	// pass options as the second argument to the constructor
	// supplied options are merged with defaults
	const headroom = new Headroom(header, options);
	headroom.init();
}
